export default __webpack_public_path__ + "static/media/do-1@2x.9821d34b.jpg";